const initCWV = () => {
    if (innerWidth <= 412) {
        improveLCP("[data-banner-slider-widget] .background-image");
        improveLCP("[data-banner-and-cta-list-widget] .background-image");
    }
};
const improveLCP = (string) => {
    const selectorList = document.querySelectorAll(`${string}`);
    selectorList.forEach((selector) => {
        setTimeout(() => {
            selector.classList.add("active");
        }, 3000);
    });
};
